import { Pipe, PipeTransform } from '@angular/core';
import { Feature, FeaturePropertyKey, StatusValueDcFeature } from '@vi-iot/client';

@Pipe({
  name: 'sensorStatusConnected',
})
export class SensorStatusConnectedPipe implements PipeTransform {
  transform(feature: Feature<unknown, unknown>): Feature<unknown, unknown> | null {
    const isSensorConnectedStatus = !!(
      feature?.properties[FeaturePropertyKey.status]?.value === StatusValueDcFeature.connected
    );

    return isSensorConnectedStatus ? feature : null;
  }
}
